import { DropDownValue } from "models/DropDownValue";

export const setOptionsList = (values: Map<string, string>) => {
  const valueList = Array.from(values)
    .map((sectionEntry) => new DropDownValue(sectionEntry[0], sectionEntry[1]));
  return valueList;
} 